import { toast } from 'sonner';

import { AUTHENTICATION_REQUIRED_ERROR } from '@/constants/auth-errors';
import { isDesktopTrayPath } from '@/lib/desktop-tray-window';
import { buildSignInPath } from '@/utils/app-paths';

/**
 * True only for a genuinely expired/missing app session: a 401 carrying the
 * canonical "Authentication required" message. Routes can forward upstream 401s
 * (e.g. a GitHub "Bad credentials" error) while the Supabase session is still
 * valid; those must not be treated as a session expiry.
 */
export function isSessionExpiredError(error: unknown): boolean {
  return (
    error instanceof Error &&
    'status' in error &&
    (error as { status?: number }).status === 401 &&
    error.message === AUTHENTICATION_REQUIRED_ERROR
  );
}

let isRedirectingToSignIn = false;

export function handleSessionExpired(): void {
  if (typeof window === 'undefined' || isRedirectingToSignIn) {
    return;
  }

  // The desktop tray popover shows its own signed-out state; the main window handles sign-in.
  if (window.location.pathname === '/sign-in' || isDesktopTrayPath(window.location.pathname)) {
    return;
  }

  isRedirectingToSignIn = true;
  toast.error('Your session has expired. Please sign in again.');

  const returnTo = `${window.location.pathname}${window.location.search}`;
  window.location.assign(buildSignInPath({ returnTo }));
}
